import { createAction } from 'redux-actions';


/*
 * Error boundary
 */
export const compDidCatchError = createAction('COMPONENT_DID_CATCH_ERROR');



// WEBPACK FOOTER //
// ./src/shared/actions/debug.js